export default "__VITE_ASSET__3y16cUOQ__"